import { useMutation, useQueryClient } from "@tanstack/react-query";
import { administratorMethods } from "../api/apiMethods";
import useSelectedMunicipalityId from "../hooks/useSelectedMunicipalityId";
import { queryKeys } from "../queries/queryKeys";
import { Logger } from "../utils/logger/Logger";
import { AdministratorInput } from "../views/AdministratorView/administratorTypes";

export const useCreateAdministratorMutation = (options: {
    onSuccess: (createdAdministratorId: string) => void;
    onError: (error: any) => void;
}) => {
    const municipalityId = useSelectedMunicipalityId();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (input: AdministratorInput) => {
            if (!municipalityId) {
                throw new Error("No municipality Id");
            }

            const administratorId = (
                await administratorMethods(municipalityId).createAdministrator(
                    input
                )
            ).administratorID;

            if (!administratorId) {
                throw new Error(
                    "Could not create a user. No user id was returned"
                );
            }

            return administratorId;
        },
        onSuccess: options.onSuccess,
        onError: async (error: Response) => {
            Logger.error(error);

            let parsedError;
            try {
                parsedError = await error.json();
            } catch {}

            options.onError(parsedError);
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.administrator.all(municipalityId),
            });
            queryClient.invalidateQueries({
                queryKey: queryKeys.orderer.all(municipalityId),
            });
        },
    });

    return mutation;
};
